import Carrito from "./carrito";

export default function CarritoMobile() {
   return <Carrito />;
}